<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12 calendar-wrapper no-border">
            <mat-label>{{ 'time-off-v3.selectAnEffectiveDate' | translate }}</mat-label>
            <input
                class="d-none"
                name="date"
                #adjustmentStartDate
                required
                matInput
                type="text"
                [ngModel]="selectedDate"
            />
            <mat-calendar #calendar [(selected)]="selectedDate"></mat-calendar>
        </mat-form-field>

        <div class="columns-6">
            <div class="app-grid">
                <div class="app-grid warning-wrapper">
                    <ui-banner variant="warning">
                        <p>{{ 'time-off-v3.allAccrualsAfterTheEffectiveDateWillBeOverwritten' | translate }}</p>
                    </ui-banner>
                </div>

                <div class="app-grid">
                    <mat-form-field>
                        <mat-label appRemoveAriaOwns>{{ 'time-off-v3.policyName' | translate }}</mat-label>
                        <mat-select name="adjustment" #adjustment [(ngModel)]="selectedTimeOffPolicyId" required>
                            <mat-option
                                *ngFor="let timeOffPolicy of timeOffPoliciesForTimeOffType"
                                [value]="timeOffPolicy.id"
                                [disabled]="timeOffPolicy.id === currentlyAssignedTimeOffPolicyId"
                                >{{ timeOffPolicy.name }}</mat-option
                            >
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</form>
